<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  // import MainEnter from "./components/FunctionReserved";
  export default {
    name: 'App',
    // components:{
    //   MainEnter
    // }
  }
</script>

<style>
  @import "../static/css/account.css";
</style>



// WEBPACK FOOTER //
// src/App.vue